import Api from '../utils/Api';
import Password from '../utils/Password';
import youtubeThumbnailResolver from '../utils/youtubeThumbnailResolver';

export default function exposeUtils() {
    window.Api = Api;
    window.Password = Password;
    window.youtubeThumbnailResolver = youtubeThumbnailResolver;
}
